// General API service - provides common API functionality by extending BaseService
import { BaseService } from './BaseService.js';

class ApiService extends BaseService {
  constructor() {
    super();
  }

  // Add any general API methods here that don't belong to specific services
  // This service can be used for endpoints that don't fit into shop, ritual, or admin categories
  
  // Example: General utility methods that multiple services might need
  async getApplicationInfo() {
    return this.publicRequest('/info');
  }

  async checkHealthStatus() {
    return this.publicRequest('/health');
  }
}

export default new ApiService();
